import { styled, useTheme } from '@mui/material';
import React__default from 'react';
import { AnimationDot } from '../Animation/AnimationDot.js';
import '../../icons/abstract/AbstractArcIcon.js';
import '../../icons/AddCircleIcon.js';
import '../../icons/AddCircleOutlineIcon.js';
import '../../icons/ArrowCircleRightIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/BoltIcon.js';
import '../../icons/BookmarkStarIcon.js';
import '../../icons/CalendarIcon.js';
import '../../icons/CancelIcon.js';
import '../../icons/CheckCircleIcon.js';
import '../../icons/CheckMarkIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronLeftIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CloseIcon.js';
import '../../icons/CopyIcon.js';
import '../../icons/MenuIcon.js';
import '../../icons/NotificationActiveIcon.js';
import '../../icons/PaperPlaneIcon.js';
import '../../icons/PendingIcon.js';
import '../../icons/PersonIcon.js';
import '../../icons/PlayCircleIcon.js';
import '../../icons/RemoveCircleIcon.js';
import '../../icons/SearchIcon.js';
import '../../icons/SellIcon.js';
import '../../icons/ShareIcon.js';
import { ShoppingBagIcon } from '../../icons/ShoppingBagIcon.js';
import '../../icons/SmartphoneIcon.js';
import '../../icons/StarIcon.js';
import '../../icons/StarOutlineIcon.js';
import '../../icons/SuccessCheckCircleIcon.js';
import '../../icons/ThumbsDownIcon.js';
import '../../icons/ThumbsUpIcon.js';
import '../../icons/TuneIcon.js';
import '../../icons/FourPointStarIcon.js';
import { ButtonName } from '../../theme/componentNames.js';
import { Button } from './Button.js';
import { parseThemeUrl } from '../../utils/stringUtils.js';

const CartCountContainer = styled('div', { label: 'CartCountContainer' })(({ bottomOffset }) => ({
    position: 'absolute',
    bottom: +bottomOffset,
    fontWeight: 600,
    lineHeight: 1.4,
}));
const CustomDtcBagButton = ({ cartCount, handleClick, mobile, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const theme = useTheme();
    const content = mobile ? (_b = (_a = theme.content) === null || _a === void 0 ? void 0 : _a.cartButton) === null || _b === void 0 ? void 0 : _b.signedOutMobile : (_d = (_c = theme.content) === null || _c === void 0 ? void 0 : _c.cartButton) === null || _d === void 0 ? void 0 : _d.signedOutDesktop;
    const customImage = parseThemeUrl((_e = content === null || content === void 0 ? void 0 : content.customIconStartSrc) !== null && _e !== void 0 ? _e : content === null || content === void 0 ? void 0 : content.customIconEndSrc);
    const enableAnimationDot = mobile
        ? !!((_g = (_f = theme === null || theme === void 0 ? void 0 : theme.settings) === null || _f === void 0 ? void 0 : _f.featureFlags) === null || _g === void 0 ? void 0 : _g.bagAnimationDotMobile)
        : !!((_j = (_h = theme === null || theme === void 0 ? void 0 : theme.settings) === null || _h === void 0 ? void 0 : _h.featureFlags) === null || _j === void 0 ? void 0 : _j.bagAnimationDot);
    const enableCartCount = mobile
        ? !!((_l = (_k = theme === null || theme === void 0 ? void 0 : theme.settings) === null || _k === void 0 ? void 0 : _k.featureFlags) === null || _l === void 0 ? void 0 : _l.cartCountNumberMobile)
        : !!((_o = (_m = theme === null || theme === void 0 ? void 0 : theme.settings) === null || _m === void 0 ? void 0 : _m.featureFlags) === null || _o === void 0 ? void 0 : _o.cartCountNumber);
    const countNumberYOffset = (_r = (_q = (_p = theme.settings) === null || _p === void 0 ? void 0 : _p.fonts) === null || _q === void 0 ? void 0 : _q.numericFontOffsetY) !== null && _r !== void 0 ? _r : 4;
    const countNumberSize = (_v = (_u = (_t = (_s = theme.componentCSSOverrides) === null || _s === void 0 ? void 0 : _s[ButtonName.BagButton]) === null || _t === void 0 ? void 0 : _t[mobile ? 'xs' : 'md']) === null || _u === void 0 ? void 0 : _u.fontSize) !== null && _v !== void 0 ? _v : 8;
    const bagButtonStyleOverride = (_x = (_w = theme.componentCSSOverrides) === null || _w === void 0 ? void 0 : _w[ButtonName.BagButton]) === null || _x === void 0 ? void 0 : _x[mobile ? 'xs' : 'md'];
    // const textContent = theme.content?.cartButton?.text;
    const textButton = !customImage;
    if (textButton) {
        const text = content === null || content === void 0 ? void 0 : content.text;
        return (React__default.createElement(Button, { disableResponsiveStyles: true, sx: Object.assign(Object.assign({}, bagButtonStyleOverride), { height: 'auto' }), variant: "text", color: "default", buttonName: ButtonName.BagButton, onClick: handleClick },
            React__default.createElement("span", null, text && cartCount && enableCartCount ? `${text} (${cartCount})` : text)));
    }
    return (React__default.createElement(Button, { variant: "icon", color: "default", buttonName: ButtonName.BagButton, onClick: handleClick, style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }, sx: bagButtonStyleOverride },
        React__default.createElement("div", { style: Object.assign({ cursor: 'pointer', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }, bagButtonStyleOverride) },
            cartCount ? (React__default.createElement(React__default.Fragment, null,
                enableAnimationDot && (React__default.createElement(AnimationDot, { className: "bc-animation-dot", size: 8, topOffset: 0, rightOffset: 0, color: 'accent', "data-theme-color": "accent" })),
                enableCartCount && (React__default.createElement(CartCountContainer, { className: "bc-cart-count-container", bottomOffset: countNumberYOffset, sx: { fontSize: countNumberSize } }, cartCount)))) : null,
            customImage ? (React__default.createElement("img", { src: customImage, alt: "Bag Icon", style: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    maxWidth: bagButtonStyleOverride === null || bagButtonStyleOverride === void 0 ? void 0 : bagButtonStyleOverride.width,
                    maxHeight: bagButtonStyleOverride === null || bagButtonStyleOverride === void 0 ? void 0 : bagButtonStyleOverride.height,
                } })) : (React__default.createElement(ShoppingBagIcon, null)))));
};

export { CustomDtcBagButton };
//# sourceMappingURL=CustomDtcBagButton.js.map
